import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import ChallengeImage from "../../components/ChallengeImage";
import StageTabs, { useAdminTheme } from "../../components/StageTabs";

/** Stage 3 — heading, question and example of the "Think Closer" challenge (add_words.php). */
export default function Words() {
  const { data, save } = useAdminTheme();
  const [title, setTitle] = useState("");
  const [question, setQuestion] = useState("");
  const [example, setExample] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!data) return;
    setTitle(String(data.landing_page_title3 ?? ""));
    setQuestion(String(data.landing_page_title3_question ?? ""));
    setExample(String(data.landing_page_title3_eg ?? ""));
  }, [data]);

  const onSave = async () => {
    let problem = "";
    if (title.trim().length === 0 || title.length > 150) {
      problem = title.trim().length === 0 ? "The title cannot be empty or contain only spaces." : "You exceed the maximum limit of the title.";
    } else if (question.trim().length === 0 || question.length > 300) {
      problem = question.trim().length === 0 ? "The subtitle cannot be empty or contain only spaces." : "You exceed the maximum limit of the subtitle.";
    } else if (example.trim().length === 0 || example.length > 150) {
      problem = example.trim().length === 0 ? "The title cannot be empty or contain only spaces." : "You exceed the maximum limit of the title.";
    }
    if (problem) return Swal.fire(problem, "", "error");

    setSaving(true);
    try {
      await save({
        landing_page_title3: title,
        landing_page_title3_question: question,
        landing_page_title3_eg: example,
      });
      Swal.fire({ title: "Data Updated", icon: "success", timer: 1000, showConfirmButton: false });
    } catch (e) {
      Swal.fire("Error", e.message || "Failed to save", "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <StageTabs />
      <div className="bp-card">
        <h4>Add Custom Heading Title For Challenge 3:</h4>
        <textarea className="bp-textarea" maxLength={150} value={title} onChange={(e) => setTitle(e.target.value)} />
        <p className="bp-note">* This title will reflect on the Challenge3 of game page &nbsp; * character limit of text is 150</p>

        <textarea className="bp-textarea" maxLength={300} value={question} onChange={(e) => setQuestion(e.target.value)} />
        <p className="bp-note">* This Question will reflect on the Challenge3 of game page &nbsp; * character limit of text is 300</p>

        <h4>Add Custom Subtitle Example:</h4>
        <textarea className="bp-textarea" maxLength={150} value={example} onChange={(e) => setExample(e.target.value)} />
        <p className="bp-note">* This subtitle will reflect on the Challenge3 of game page &nbsp; * character limit of text is 150</p>

        <div className="bp-actions">
          <button type="button" className="bp-btn" onClick={onSave} disabled={saving}>
            Save
          </button>
        </div>
      </div>

      <ChallengeImage stage={3} />
    </>
  );
}
